import styled from 'styled-components';
import { textblocks } from 'seal-ui-components';
import { getBaseTheme } from '@Themes';

const { spaces, colors, texts } = getBaseTheme();

export const FilterWrapper = styled.div``;

export const FilterDiv = styled.div`
    display: block;
    margin-top: ${spaces.default.s};

    > div {
        > div li {
            ${texts.sizes.xs};
            padding: ${spaces.default.xs};
        }
    }
`;

export const QuickFilterWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    flex: 1;
    flex-direction: column;
    padding: ${spaces.default.s};
    background-color: ${colors.banner.info.foregroundColor};
`;

export const QuickFilterHeader = styled.div`
    height: 2.4rem;
    display: flex;
    justify-content: space-between;
`;

export const InBodyTitle = styled(textblocks.Text)`
    ${texts.sizes.s};
    margin-top: ${spaces.default.xs};
`;

export const StyledCheckBoxWrapper = styled.div`
    display: flex;
    justify-content: space-around;
    width: 50%;
`;

export const CheckBoxFilterDiv = styled.div`
    display: flex;
    align-items: baseline;
    margin-top: 0.625rem;
`;
